import React, { useState } from 'react';

import ContainerPropsSchema, { ContainerProps } from '../../../../documents/blocks/Container/ContainerPropsSchema';

import BaseSidebarPanel, { SectionHeader } from './helpers/BaseSidebarPanel';
import MultiStylePropertyPanel from './helpers/style-inputs/MultiStylePropertyPanel';

type ContainerSidebarPanelProps = {
  data: ContainerProps;
  setData: (v: ContainerProps) => void;
};

export default function ContainerSidebarPanel({ data, setData }: ContainerSidebarPanelProps) {
  const [, setErrors] = useState<Zod.ZodError | null>(null);

  const updateData = (d: unknown) => {
    const res = ContainerPropsSchema.safeParse(d);
    if (res.success) {
      setData(res.data);
      setErrors(null);
    } else {
      setErrors(res.error);
    }
  };

  return (
    <BaseSidebarPanel title="Container block">
      <div className="space-y-4">
        <SectionHeader>Layout</SectionHeader>
        <div className="space-y-3">
          <MultiStylePropertyPanel
            names={['backgroundColor', 'borderColor', 'borderRadius', 'padding']}
            value={data.style}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>
    </BaseSidebarPanel>
  );
}
